import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { CreditBillReciptMstData, CreditBillReciptMst } from '../../../interfaces/pharmacy/CreditBillReceiptMst';
import { CreditBillReciptApi } from '../api/CreditBillRecipt.api';
@Injectable() 
export class CreditBillReciptService extends CreditBillReciptMstData{
 
  constructor(private api: CreditBillReciptApi) {
    super();
  } 

  getall(url: string): Observable<CreditBillReciptMst[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<CreditBillReciptMst>{
    return this.api.getby_id(url);
  }

  create(url: string, data:CreditBillReciptMst): Observable<CreditBillReciptMst[]> {
    return this.api.add(url,data);
  }

  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

}
